import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const images = [
  { src: '/img/11.jpeg', text: 'Welcome to Our Website' },
  { src: '/img/29.jpeg', text: 'Discover Our Services' },
  { src: '/img/2.jpeg', text: 'Quality Assurance Guaranteed' },
  { src: '/img/8.jpeg', text: 'Our Mission and Vision' },
  { src: '/img/13.jpeg', text: 'Contact Us Today' },
];

// Styled components using Material-UI's `styled` API
const HeroContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '70vh', // Default height for small screens
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    height: '100vh', // Full height for medium and large screens
  },
}));

const HeroSlide = styled(Box)(({ active, src }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundImage: `url(${src})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  opacity: active ? 1 : 0,
  transition: 'opacity 1s ease-in-out',
}));

const HeroText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  bottom: '30%', // Moved text higher
  left: '50%',
  transform: 'translateX(-50%)',
  color: 'white',
  fontSize: '2rem',
  fontWeight: 'bold',
  textAlign: 'center',
  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
  [theme.breakpoints.up('md')]: {
    fontSize: '3rem', // Larger text for bigger screens
  },
}));

const ArrowButton = styled(IconButton)({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'white',
  zIndex: 10,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
});

function Hero() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const handlePrevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const handleNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <HeroContainer id="home">
      {images.map((image, index) => (
        <HeroSlide
          key={index}
          src={image.src}
          active={index === currentIndex}
        >
          <HeroText>{image.text}</HeroText>
        </HeroSlide>
      ))}
      <ArrowButton onClick={handlePrevSlide} sx={{ left: '10px' }}>
        <ArrowBackIosIcon />
      </ArrowButton>
      <ArrowButton onClick={handleNextSlide} sx={{ right: '10px' }}>
        <ArrowForwardIosIcon />
      </ArrowButton>
    </HeroContainer>
  );
}

export default Hero;